<h4 style="text-align: center;">Matriz ssoma</h4>

<div class="text-center">
    <div class="btn-group">
      <input
        mdbRadio
        type="radio"
        class="btn-check"
        name="options"
        id="option1"
        autocomplete="off"
        [checked]="false"
        (click)="loadPdf('SSOMA Emergencias Rev 3 2019.pdf')"
      />
      <label class="btn btn-secondary" for="option1">EMERGENCIAS</label>
  
      <input
        mdbRadio
        type="radio"
        class="btn-check"
        name="options"
        id="option2"
        autocomplete="off"
        [checked]="false"
        (click)="loadPdf('SSOMA Planta Rev 3 2019.pdf')"
      />
      <label class="btn btn-secondary" for="option2">PLANTA</label>
  
      <input
        mdbRadio
        type="radio"
        class="btn-check"
        name="options"
        id="option3"
        autocomplete="off"
        [checked]="false"
        (click)="loadPdf('SSOMA Mantención Rev 3 2019.pdf')"
      />
      <label class="btn btn-secondary" for="option3">MANTENCION</label>

      <input
        mdbRadio
        type="radio"
        class="btn-check"
        name="options"
        id="option3"
        autocomplete="off"
        [checked]="false"
        (click)="loadPdf('SSOMA Bodega RESPEL Rev 3 2019.pdf')"
      />
      <label class="btn btn-secondary" for="option3">BODEGA</label>

      <input
        mdbRadio
        type="radio"
        class="btn-check"
        name="options"
        id="option3"
        autocomplete="off"
        [checked]="false"
        (click)="loadPdf('SSOMA Administrativos y Ventas Rev 3 2019.pdf')"
      />
      <label class="btn btn-secondary" for="option3">ADMINISTRATIVOS Y VENTAS</label>
    </div>
  </div> 


<br>
  <div class="pdf-container">
    <iframe [src]="pdfSrc" width="100%" height="720px"></iframe>
  </div>
